module.exports = __webpack_public_path__ + "img/wallet (1).1a965f5d.svg";